<template>
  <div>
    <input v-model="searchKeyword" placeholder="输入地址进行搜索" />
    <button @click="searchAddress(searchKeyword)">搜索</button>
    <div id="container" class="map"></div>
    <div class="info">
      <p v-if="selectedLngLat">选中经纬度: {{ selectedLngLat }}</p>
<!--      <p v-if="address">详细地址: {{ address }}</p>-->
<!--      <p v-if="province">省份: {{ province }}</p>
      <p v-if="city">城市: {{ city }}</p>
      <p v-if="district">区县: {{ district }}</p>-->
    </div>
  </div>
</template>

<script>
export default {
  name: 'MapSelect',
  props: {
    initialLngLat: {
      type: Object,
      default: null // 默认值为 null，表示没有初始经纬度
    }
  },
  data() {
    return {
      map: null,
      marker: null,
      selectedLngLat: null,
      selectedLocation: null,
      address: '',
      province: '',
      city: '',
      district: '',
      searchKeyword: ''
    };
  },
  mounted() {
    this.initMap();
  },
  methods: {
    initMap() {
      this.map = new AMap.Map('container', {
        zoom: 10, // 设置地图显示的缩放级别
        //center: this.initialLngLat.lng == null ? [116.397428, 39.90923]:[this.initialLngLat.lng, this.initialLngLat.lat]  // 设置地图中心点坐标
        center: [116.397428, 39.90923]
      });

      this.map.on('click', (e) => {
        this.handleMapClick(e);
      });

      // if (this.initialLngLat.lng != null) {
      //   this.addMarker(this.initialLngLat);
      // }
    },

    // ...其他方法
    searchAddress(keyword) {
      AMap.plugin('AMap.PlaceSearch', () => {
        const placeSearch = new AMap.PlaceSearch({
          type: 'POI', // 搜索类型
          pageSize: 5, // 单页显示结果数量
          pageIndex: 1, // 页码
          city: '全国' // 城市
        });

        placeSearch.search(keyword, (status, result) => {
          if (status === 'complete' && result.info === 'OK') {
            if (result.poiList.pois.length > 0) {
              const firstPoi = result.poiList.pois[0];
              const lnglat = [firstPoi.location.lng, firstPoi.location.lat];
              this.map.setCenter(lnglat); // 将地图中心移动到搜索结果的位置
              this.addMarker({ lng: firstPoi.location.lng, lat: firstPoi.location.lat }); // 添加标记
            }
          } else {
            console.error('搜索地址失败', result);
          }
        });
      });
    },

    addMarker(lnglat){

      // 移除之前的标记
      if (this.marker) {
        this.map.remove(this.marker);
      }

      // 添加新的标记
      this.marker = new AMap.Marker({
        position: [llnglat.lng, lnglat.lat],
        map: this.map,
        title: '选中位置',
        icon: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png' // 自定义标记图标
      });

      // // 更新选中经纬度
      // this.selectedLngLat = `经度: ${lnglat.lng.toFixed(6)}, 纬度: ${lnglat.lat.toFixed(6)}`;
      // //  console.log("选中位置:" + this.selectedLocation);
      //
      // // 通过自定义事件将数据传递给父组件
      // this.selectedLocation = {
      //   lng: lnglat.lng.toFixed(6),
      //   lat: lnglat.lat.toFixed(6)
      // }
      // this.$emit('location-selected', this.selectedLocation)
    },
    handleMapClick(e) {
      const { lng, lat } = e.lnglat;

      // 移除之前的标记
      if (this.marker) {
        this.map.remove(this.marker);
      }

      // 添加新的标记
      this.marker = new AMap.Marker({
        position: [lng, lat],
        map: this.map,
        title: '选中位置',
        icon: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png' // 自定义标记图标
      });

      // 更新选中经纬度
      this.selectedLngLat = `经度: ${lng.toFixed(6)}, 纬度: ${lat.toFixed(6)}`;
    //  console.log("选中位置:" + this.selectedLocation);

      // 通过自定义事件将数据传递给父组件
      this.selectedLocation = {
        lng: lng.toFixed(6),
        lat: lat.toFixed(6)
      }
      this.$emit('location-selected', this.selectedLocation)
      // this.$emit('location-selected', {
      //   lngLat: this.selectedLngLat,
      //   address: this.address,
      //   // province: this.province,
      //   // city: this.city,
      //   // district: this.district
      // });

      // 获取详细地址
    //  this.getAddress(lng, lat);
    },
    getAddress(lng, lat) {
      if (typeof AMap.plugin !== 'function') {
        console.error('AMap.plugin is not a function');
        return;
      }

      AMap.plugin('AMap.Geocoder', () => {
        const geocoder = new AMap.Geocoder({
          radius: 1000, // 范围，默认：500
          extensions: 'all' // 返回信息详细程度，默认：base
        });

        geocoder.getAddress([lng, lat], (status, result) => {
          if (status === 'complete' && result.info === 'OK') {
            if (result.regeocode) {
              this.address = result.regeocode.formattedAddress;
              this.province = result.regeocode.addressComponent.province;
              this.city = result.regeocode.addressComponent.city;
              this.district = result.regeocode.addressComponent.district;
              console.log(`详细地址: ${this.address}`);
              console.log(`省份: ${this.province}, 城市: ${this.city}, 区县: ${this.district}`);
              console.log("经纬度：" + this.selectedLngLat);
              // 可以在这里将地址信息显示在页面上或其他操作
            }
          } else {
            console.error('获取地址失败', result);
          }
        });
      });
    }
  }
};
</script>

<style scoped>
.map {
  width: 100%;
  height: 600px;
}

/*.info {*/
/*  margin-top: 20px;*/
/*  padding: 10px;*/
/*  background-color: #f9f9f9;*/
/*  border: 1px solid #ddd;*/
/*}*/
</style>
